import { GlobalAppState } from 'rdx/state';

export const selectSupportMainEntryWidgetUrlState = (state: GlobalAppState) => {
  return state.support.mainEntryWidgetUrl;
};

export const selectFetchingMainEntryWidgetUrlState = (state: GlobalAppState) => {
  return state.support.fetchingMainEntryWidgetUrlState;
};

export const selectSupportCaseUrlState = (state: GlobalAppState) => {
  return state.support.supportCaseUrl;
};

export const selectFetchingSupportCaseUrlState = (state: GlobalAppState) => {
  return state.support.fetchingSupportCaseUrlState;
};

export const selectUnreadCasesState = (state: GlobalAppState) => {
  return state.support.unreadCases;
};

export const selectFetchingUnreadCasesState = (state: GlobalAppState) => {
  return state.support.fetchingUnreadCasesState;
};

export const selectMqttConnectionInfoState = (state: GlobalAppState) => {
  return state.support.mqttConnectionInfo;
};

export const selectFetchingMqttConnectionInfo = (state: GlobalAppState) => {
  return state.support.fetchingMqttConnectionInfo;
};

export const selectSupportSelectedCaseState = (state: GlobalAppState) => {
  return state.support.selectedCase;
};
